import React from "react";
import * as CONSTANT from "../../constants";
import { ArrowImage, ArrowMobImage} from "../../images/svgIcons/svg";
import styles from "./page404.module.scss";
import StrawberryImage from '../../../src/images/desktopStrawberry.png';
import MobStrawberryImage from '../../../src/images/mobStrawberry.png';

const Page404 = () => {
  return (
    <>
      <div className="container py-5">
        <div className={`${styles.strawberrySection}`}>
          <div className="d-flex justify-content-center align-items-center">
          <span className="font-Visby-cf f-w9 clr-dark-blue">4</span>
          <img src={StrawberryImage} alt='Strawberry Image' className="d-md-block d-none"/>
          <img src={MobStrawberryImage} alt='Strawberry Image' className="d-md-none d-block"/>
          <span className="font-Visby-cf f-w9 clr-dark-blue">4</span>
          </div>
        </div>
        <div className="mb-5">
          <h1 className="font-Cls f-s45 f-sm-s16 f-w4 clr-dark-blue ls-normal mb-3">
            Oops! We Couldn’t Find The Page.
          </h1>
          <div className="d-flex justify-content-center gap-4 pb-md-4">
            <p className="font-Trade-regular f-w4 f-s24 f-sm-s14">Try another one of these helpful pages</p>
           <div className="mt-3 d-md-block d-none"> <ArrowImage/></div>
           <div className="mt-3 d-md-none d-block"><ArrowMobImage/></div>
          </div>
          <div className={`${styles.ordersBtn}`}>
            <a
              href={CONSTANT.ROUTE_MENU}
              className="btn btn-large text-uppercase font-Visby-cf f-s20 f-sm-s14 f-w7 mx-3 py-2 my-2 px-4"
            >
              order online
            </a>
            <a
              href={CONSTANT.ROUTE_HOME}
              className="btn btn-large font-Visby-cf f-s20 f-sm-s14 f-w7  text-uppercase mx-3 py-2 my-2 px-4"
            >
              return home
            </a>
          </div>
        </div>
      </div>
</>
  );
};

export default Page404;
